<template>
    <div>
    
      <el-form-item label="비용구분" prop="expenseCategories">

        <el-select
            v-model="localSelectedValue"
            placeholder="비용구분을 선택하세요"
            style="width: 100%"
            @change="handleSelectionChange"
        >
            <!-- 기존 비용구분 옵션 -->
            <el-option
            v-for="method in codeStore.expenseCategories"
            :key="method.id"
            :label="method.name"
            :value="method.id"
            />
            <!-- 비용구분 추가 옵션 -->
             <!--
            <el-option :value="'add_new'" :key="'add_new'" label="추가하기" />
            -->
        </el-select>
      </el-form-item>
  
      <!-- 비용구분분 입력 모달 -->
      <el-dialog
        title="비용구분  추가"
        v-model="showModal"
        width="30%"
        @close="resetForm"
      >
        <el-form :model="formData" :rules="rules" ref="formRef" label-width="120px">
          <el-form-item label="비용구분 이름" prop="name">
            <el-input v-model="formData.name" placeholder="비용구분이름을 입력하세요" />
          </el-form-item>
        </el-form>
  
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="closeModal">취소</el-button>
            <el-button type="primary" @click="save">저장</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script setup>
  import { ref, watch,defineEmits,onMounted } from 'vue';
  import axiosInstance from '@/api/axios';
  import {  ElMessage } from 'element-plus'; // 메시지 박스와 메시지 컴포넌트
  import { useCodeStore } from "@/stores/codeStore"; // Pinia 스토어 가져오기

  // Props 정의
  const props = defineProps({
    modelValue: {
      type: [ Number,String], // 선택된 결제 방법
      required: true,
    },

  });
 
  const formRef = ref(null);
  const codeStore = useCodeStore();

  const emits = defineEmits(['update:modelValue']);

  // 로컬 상태 정의
const localSelectedValue = ref(props.modelValue);

  // 상태 관리
  const showModal = ref(false); // 모달 표시 여부
  const formData = ref({
    name: '', // 새 비용구분분 이름
  });
  const rules = {
    name: [{ required: true, message: '비용구분  이름을 입력하세요.', trigger: 'blur' }],
  };
  
  // 선택 항목 변경 처리
  const handleSelectionChange = (value) => {
    if (value === 'add_new') {
      showModal.value = true;
    } else {
      
      emits('update:modelValue');
      console.log(value)
    }
  };
  
  // 모달 초기화
  const resetForm = () => {
    formData.value.name = '';
  };
  
  // 모달 닫기
  const closeModal = () => {
    showModal.value = false;
    resetForm();
  };
  
  // 결제 방법 저장
  const save = () => {
    formRef.value.validate(async (valid) => {
      if (valid) {
        // 새 결제 방법을 추가하는 API 호출 (예제)
        try {
          console.log('새 비용구분 추가:', formData.value.name);
          await axiosInstance.post('expense-category/',formData.value);
          closeModal();
          ElMessage.success("새 비용구분 추가완료")
          codeStore.fetchExpenseCategories();
        } catch (error) {
          console.error(' 비용 구분 저장 실패:', error);
          ElMessage.error("비용 구분 저장 실패")
        }
      }
    });
  };

  onMounted(async () => {
      try{
        await codeStore.fetchExpenseCategories();
      
      }catch(error){
        console.log(error)
      }finally{
        console.log(" 패치완료")
      }
      
    });




watch(
  () => props.modelValue,
  (newValue) => {
    localSelectedValue.value = newValue;
  }
);


  </script>
  
  <style scoped>
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
  </style>
  